<script lang="ts">
  export let className: string = "";
  export let svgClass: string = "";
  export let file: string;
  export let width: string | undefined = undefined;
  export let height: string | undefined = undefined;

  $: parsedSvg = file
    ?.replace(/<svg([^>]*)>/, (match, attrs) => {
      const existingClasses = attrs.match(/class="([^"]*)"/);
      if (existingClasses) {
        const newClasses = existingClasses[1] + " " + svgClass;
        return `<svg${attrs.replace(existingClasses[0], `class="${newClasses}"`)}>`;
      } else {
        return `<svg${attrs} class="${svgClass}">`;
      }
    })
    ?.replace(/width="([^"]*)"/, (match, originalWidth) => (width ? `width="${width}"` : `width="${originalWidth}"`))
    ?.replace(/height="([^"]*)"/, (match, originalHeight) =>
      height ? `height="${height}"` : `height="${originalHeight}"`,
    );
</script>

<div class={className}>
  {@html parsedSvg}
</div>
